const {Component} = require("react");

class Singleton {

	getMethodsOf(ori_obj) {
		var props = [];
		let obj = Object.create(ori_obj);

		let iterator = obj;

		while (iterator !== null && iterator.constructor !== Component.prototype.constructor) {
			props = props.concat(Object.getOwnPropertyNames(iterator));
			iterator = Object.getPrototypeOf(iterator);			
		}

		props = props.sort().filter((e, i, arr) => (
			e !== arr[i+1] &&
			e !== 'constructor' &&
			typeof obj[e] === 'function'
		));

		return props;
	}

	extend = (obj) => {

		this.container = true;

		this.getMethodsOf(obj)
			.forEach(method => {
				if (this[method]) {
					const name = this.constructor.name;
					throw `Method name conflict in ${name}: ${method}`;
				}

				this[method] = (...args) => obj[method](...args);
			});
	}

    hasContainer() {
        return typeof(this.container) !== 'undefined';
    }

}

module.exports = Singleton;
